import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import { createSelector } from 'reselect'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import { USER_KEY } from '@gymaholic/packages'

const getStripeSubscriptionIdsUserSelect = createSelector(
  getCurrentTrainingUserSelect,
  (user) => getValueReduxUtil(user, USER_KEY.STRIPE_SUBSCRIPTION_IDS)
)

export default getStripeSubscriptionIdsUserSelect
